import { useState } from "react";
import Button from "../../../../components/button/Button";
import RadioButtons from "../../../../components/radioButtons/RadioButtons";
import TextArea from "../../../../components/textarea/TextArea";
import TextBox from "../../../../components/textBox/TextBox";
import useTranslation from "../../../../hooks/i18n/useTranslation";
import { sendSupportEmail } from "../../../../services/api/Support";

const EmailForm = () => {
  const { t } = useTranslation();

  const MessageType = {
    QUESTION: t("327"),
    FEEDBACK: t("328"),
    BUG_REPORT: t("329"),
    FEATURE_REQUEST: t("330"),
  };

  const [formData, setFormData] = useState({
    messageType: MessageType.QUESTION,
    title: "",
    message: "",
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState(null);
  const [submitSuccess, setSubmitSuccess] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const handleRadioChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      messageType: e.target.value,
    }));
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.title.trim()) {
      newErrors.title = t("332");
    }
    if (!formData.message.trim()) {
      newErrors.message = t("340");
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;
    setIsSubmitting(true);
    setSubmitError(null);
    try {
      await sendSupportEmail({
        messageType: formData.messageType,
        title: formData.title,
        message: formData.message,
      });
      setSubmitSuccess(true);
      setFormData({
        messageType: MessageType.QUESTION,
        title: "",
        message: "",
      });
    } catch (error) {
      setSubmitError(t("472"));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-form">
      <div className="form-section">
        <RadioButtons
          options={Object.values(MessageType)}
          selectedOption={formData.messageType}
          onChange={handleRadioChange}
          name={t("331")}
        />
      </div>

      <div className="form-section">
        <div className="form-label App-text-medium App-bold-text">
          {t("332")} *
        </div>
        <TextBox
          placeholder={t("333")}
          value={formData.title}
          name="title"
          onChange={handleInputChange}
          error={errors.title}
          mandatory={false}
        />
        {errors.title && (
          <div className="error-message App-text-small">{errors.title}</div>
        )}
      </div>

      <div className="form-section">
        <div className="form-label App-text-medium App-bold-text">
          {t("334")}
        </div>
        <TextArea
          placeholder={t("335")}
          value={formData.message}
          name="message"
          onChange={handleInputChange}
        />
        {errors.message && (
          <div className="error-message App-text-small">{errors.message}</div>
        )}
      </div>

      <div className="form-actions">
        {submitSuccess && (
          <div className="App-text-medium" style={{ color: "green" }}>{t("341")}</div>
        )}
        {submitError && (
          <div className="App-text-small error-message">{submitError}</div>
        )}
        <Button value={t("339")} onClick={handleSubmit} disabled={isSubmitting} />
      </div>
    </div>
  );
};

export default EmailForm;

